<template>
  <div :class="space == false  ? '': 'py-2' ">     
    <div class="inline-flex items-center text-xs font-medium text-indigo-600"><span class="uppercase text-[11px]" >{{label}}</span></div>    
  </div>
</template>

<script>

export default {
    name: 'TextSub',
    props: {
        label: String,
        space: Boolean,
    },

}
</script>